import React, { useEffect, useState } from 'react';
import MasterHeader from '../../component/reusable/MasterHeader'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getAllCategoriesThunk, setCategoryRefresh } from '../../redux/category/getAllCategorySlice';
import api from '../../utils/api';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase, styled, Button } from '@mui/material';
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import { Add } from '@mui/icons-material';
import { AddUser } from '../../Svg';


const AddCategoryButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '0.875rem',
    backgroundColor: '#512DA8',
    color: '#fff',
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: '#512DA8',
        opacity: '0.65',
    },
}));

const FirstUser = () => {
    const [statuss, setStatus] = useState("");
    const [search, setSearch] = useState('');
    const navigate = useNavigate()
    /* const handleFileChange = async (e) => {
      try {
        const file = e.target.files[0];
        if (!file) return;
  
        const formData = new FormData();
        formData.append('file', file);
  
        const response = await api.addBulkCategory(formData);
        if (response.data) {
          toast.success(response?.data?.data?.message)
          dispatch(setCategoryRefresh());
        }
      } catch (err) {
        console.log(err);
        toast.error(err?.response?.data?.message || 'Something went wrong')
      }
    }; */
    return (
        <div>
            <MasterHeader
                index="Admin Users"
                root="Dashboard"
                setStatus={setStatus}
                setSearch={setSearch}
                /* handleFileChange={handleFileChange} */
                onClickadd={() => navigate('/master/addCategory')}
                buttonText={'Add User'}
            />

            <div className={styles.card}>
                <div style={{
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "26px",
                    height: '60vh',
                }}>
                    <img src='/assets/addusers.png' />
                    <div>
                        <h3 style={{ color:'#131523', fontSize:"20px", fontWeight:"700", textAlign:'center'}}>Add First User</h3>
                        <p style={{ color:'#5A607F', fontSize:"16px", textAlign:'center', paddingTop:"10px"}}> No users are created yet!</p>
                    </div>
                    <AddCategoryButton startIcon={<Add />}>Add New User</AddCategoryButton>
                </div>
            </div>
        </div>
    )
}

export default FirstUser
